module.exports = __webpack_public_path__ + "610adb0448510d742c8c3085afe850d2.svg";